/* See https://www.algolia.com/doc/integration/shopify/advanced-customization/customizing-instant-search/#hogan */

(function(algolia) {
  // 'use strict';
  var Hogan = algolia.externals.Hogan;

  var formatPrice = function formatPrice(value) {
    return algolia.formatMoney(Number(value) * 100);
  };

  function formattedPriceWithComparison(price, compare_at_price, price_ratio) {
    var comparing =
      Number(compare_at_price) && Number(compare_at_price) > Number(price);
    var discount_ratio = 1.0 - price_ratio;
    //custom
    var discountClass = comparing ? "comparing" : "";
    var res = '<b class="' + discountClass + '">' + formatPrice(price) + '</b>';
    // endcustom
    if (comparing) {
      res +=
        ' <span class="ais-hit--price-striked">' +
        formatPrice(compare_at_price) +
        '</span> ';
      res +=
        ' <span class="ais-hit--price-discount" style="font-weight: ' +
        Math.floor(discount_ratio * 10) * 100 +
        ';">-' +
        Math.floor(discount_ratio * 100) +
        '%</span>';
    }

    return res;
  }

  var escapeHtml = function escapeHtml(unsafe) {
    return (unsafe || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  };

  algolia.helpers = {
    formatNumber: function formatNumber(text, render) {
      return Number(render(text)).toLocaleString();
    },
    formattedPrice: function formattedPrice(text, render) {
      return formatPrice(render(text));
    },
    formattedPriceWithoutDecimals: function formattedPriceWithoutDecimals(
      text,
      render
    ) {
      return formatPrice(render(text)).replace(/\.\d+$/, '');
    },
    autocompletePrice: function autocompletePrice() {
      if (this._distinct) {
        var min = this.variants_min_price;
        var max = this.variants_max_price;
        if (min !== max) {
          return '<b>' + formatPrice(min) + ' - ' + formatPrice(max) + '</b>';
        }
      }
      return formattedPriceWithComparison(this.price, null);
    },
    instantsearchPrice: function instantsearchPrice() {
      if (this._distinct) {
        var min = this.variants_min_price;
        var max = this.variants_max_price;
        if (min !== max) {
          return '<b>' + formatPrice(min) + ' - ' + formatPrice(max) + '</b>';
        }
      }
      return formattedPriceWithComparison(
        this.price,
        this.compare_at_price,
        this.price_ratio
      );
    },
    instantsearchLink: function instantsearchLink() {
      var addVariantId = !this._distinct && this.objectID !== this.id;
      return (
        '/products/' +
        this.handle +
        (addVariantId ? '?variant=' + this.objectID : '')
      );
    },
    fullTitle: function fullTitle() {
      var res = this.title;
      if (
        !this._distinct &&
        this.variant_title &&
        this.variant_title !== 'Default Title' &&
        this.variant_title !== 'Default'
      ) {
        res += ' (' + this.variant_title + ')';
      }

      return escapeHtml(res);
    },
    fullHTMLTitle: function fullHTMLTitle() {
      var res = '';

      if (this._highlightResult.title && this._highlightResult.title.value) {
        res = algolia.helpers.fullEscapedAttribute(
          this._highlightResult.title.value
        );
      }
      if (
        !this._distinct &&
        this.variant_title &&
        this.variant_title !== 'Default Title' &&
        this.variant_title !== 'Default'
      ) {
        //CUSTOM
        if(this.option2 !== null && this.option2 !== undefined ){
          res += ' <span class="algolia-variant products__item-variant">' + this.option2 + '</span>'
        }else{
          res += ' <span class="algolia-variant products__item-variant">' + this.option1 + '</span>'
        }
        //END CUSTOM
      }
      return res;
    },
    fullEscapedAttribute(attribute) {
      return new DOMParser().parseFromString(attribute, 'text/html')
        .documentElement.textContent;
    },
    fullEscapedHTMLTitle: function fullEscapedHTMLTitle() {
      var res = '';

      if (this._highlightResult.title && this._highlightResult.title.value) {
        res = algolia.helpers.fullEscapedAttribute(
          this._highlightResult.title.value
        );
      }

      if (
        !this._distinct &&
        this.variant_title &&
        this.variant_title !== 'Default Title' &&
        this.variant_title !== 'Default'
      ) {
         //CUSTOM
         if(this.option2 !== null && this.option2 !== undefined ){
          res += ' <span class="algolia-variant products__item-variant">' + this.option2 + '</span>'
        }else{
          res += ' <span class="algolia-variant products__item-variant">' + this.option1 + '</span>'
        }
        //END CUSTOM
      }

      return res;
    },
    fullEscapedHTMLProductType: function fullEscapedHTMLProductType() {
      if (
        this._highlightResult.product_type &&
        this._highlightResult.product_type.value
      ) {
        return algolia.helpers.fullEscapedAttribute(
          this._highlightResult.product_type.value
        );
      } else {
        return '';
      }
    },
    fullEscapedHTMLVendor: function fullEscapedHTMLVendor() {
      if (this._highlightResult.vendor && this._highlightResult.vendor.value) {
        return algolia.helpers.fullEscapedAttribute(
          this._highlightResult.vendor.value
        );
      } else {
        return '';
      }
    },
    //CUSTOM
    productBadge: function productBadge(){
      var tagValue = '';
      var langTag = '';
      var langAvisa = '';
      var htmlBIS = '';
      if(this._highlightResult.pre_order_date.value !== ""){
        tagValue = "Prevendita"
      }
      else
      {
        this._highlightResult.tags.forEach(function(tag){
          if(tag.value.indexOf("badge:") > -1){
              var badge = tag.value.replace('badge:', '');
            if(badge.trim() !== "pre-ordine"){
              tagValue = badge
            } 
            if (badge.trim() === "sold-out") {
              tagValue = badge.trim().replace('-', ' ');
              const lang = document.documentElement.lang;

              if ( lang == "it") {
                langTag = "Esaurito";
                langAvisa = "Avvisami";
              } else if ( lang == "de" ) {
                langTag = "Ausverkauft";
                langAvisa = "Benachrichtige mich";
              } else if ( lang == "fr" ) {
                langTag = "Épuisé";
                langAvisa = "Prévenez-moi";
              } else {
                langTag = "Sold out";
                langAvisa = "Notify me";
              }

              htmlBIS = `<div class="product_soldout_bis" data-product-id="" data-product-variant="">
              <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 512 512"><path d="M64 112c-8.8 0-16 7.2-16 16v22.1L220.5 291.7c20.7 17 50.4 17 71.1 0L464 150.1V128c0-8.8-7.2-16-16-16H64zM48 212.2V384c0 8.8 7.2 16 16 16H448c8.8 0 16-7.2 16-16V212.2L322 328.8c-38.4 31.5-93.7 31.5-132 0L48 212.2zM0 128C0 92.7 28.7 64 64 64H448c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128z"/></svg>
              ${langAvisa}</div>`;

            }
        
          }
        })
      }
      //console.log('productBadge =' + tagValue)
      let badge_type = tagValue.trim().toLowerCase().replace(" ","");
      if ( langTag != '' ) { tagValue = langTag; }
      return tagValue != '' ? `<div class="products__item-preorder product_badge_${badge_type}" data-type-badge="${badge_type}">${tagValue}</div>${htmlBIS}` : '';
    },
    productTag: function productTag(){
      var tagValue='';
      this._highlightResult.tags.forEach(function(tag){
        if(tag.value.indexOf("tag:") > -1){
            var badge = tag.value.replace('tag:', '');
            tagValue = badge
            return tagValue != '' ? `<span class="products__item-badge" data-badge="${tagValue}">${tagValue}</span>` : '';
        }
      })
      return tagValue != '' ? `<span class="products__item-badge" data-badge="${tagValue}">${tagValue}</span>` : '';
    },
    floor: function floor(text, render) {
      return '' + Math.floor(Number(render(text)));
    },
    ceil: function ceil(text, render) {
      return '' + Math.ceil(Number(render(text)));
    },
    sizedImage: function sizedImage(text, render) {
      var image = this._distinct ? this.product_image : this.image;
      if (!image) {
        return 'http://cdn.shopify.com/s/images/admin/no-image-compact.gif';
      }
      var size = render(text).replace(/^\s+|\s+$/g, ''); // Render and trim
      if (size === 'original') {
        return image;
      }
      return image.replace(/\/(.*)\.(\w{2,4})/g, '/$1_' + size + '.$2');
    },
    //CUSTOM COLORS
    formatFilter: function(text, render){
      var filter = render(text)
      if(filter.indexOf("|#") > -1){
        var colors = filter.split('|');
        var colorName = colors[0];
        var colorCode = colors[1];
        return `${colorName}<span class="ais-facet--label__color" style="background-color:${colorCode}"></span>`
      }
      if(filter == "true"){
        return `Mostra prodotti in pre-vendita`
      }
      if(filter == "false"){
        return `Mostra prodotti in pronta consegna`
      }
      return filter
    },
  };

  [
    'pico',
    'icon',
    'thumb',
    'small',
    'compact',
    'medium',
    'large',
    'grande',
    'original',
  ].forEach(function(size) {
    algolia.helpers[size + 'Image'] = (function(_size) {
      return function() {
        var image = this._distinct ? this.product_image : this.image;

        if (!image) {
          return 'http://cdn.shopify.com/s/images/admin/no-image-compact.gif';
        }

        if (_size === 'original') {
          return image;
        }

        return image.replace(/\/(.*)\.(\w{2,4})/g, '/$1_' + _size + '.$2');
      };
    })(size); // We need to create a new scope so that the internal size has the good value.
  });

  /* Create an Hogan lambda, which doesn't respect the mustache doc */
  var helpers = algolia.assign(
    {},
    algolia.helpers,
    algolia.translation_helpers
  );
  var helpersNames = Object.keys(helpers);
  var i = helpersNames.length;
  var helpersArray = new Array(i);
  while (i--) helpersArray[i] = [helpersNames[i], helpers[helpersNames[i]]];

  algolia.hoganHelpers = helpersArray.reduce(function(res, options) {
    var name = options[0];
    var helper = options[1];

    var newRes = algolia.assign({}, res);

    newRes[name] = function() {
      return function(text) {
        var render = function(value) {
          return Hogan.compile(value, algolia.hoganOptions).render(this);
        }.bind(this);

        return helper.call(this, text, render);
      }.bind(this);
    };

    return newRes;
  }, {});
})(window.algoliaShopify);
